import { initializeApp } from "firebase/app";

// DEV;
// export default initializeApp({
//   apiKey: "AIzaSyB7NHwalaj0Cd60rNsBWtsvMJ5V6jSTGSE",
//   authDomain: "dev-assembly-row.firebaseapp.com",
//   databaseURL: "https://dev-assembly-row.firebaseio.com",
//   projectId: "dev-assembly-row",
//   storageBucket: "dev-assembly-row.appspot.com",
//   messagingSenderId: "408924997861"
// });

export default initializeApp({
  apiKey: "AIzaSyCrAb79Dh7yFnWNZAcrQEwU-LlbU6vpnxg",
  authDomain: "assembly-row.firebaseapp.com",
  databaseURL: "https://assembly-row.firebaseio.com",
  projectId: "assembly-row",
  storageBucket: "assembly-row.appspot.com",
  messagingSenderId: "747428626717"
});



// WEBPACK FOOTER //
// ./src/firebase-config.js